import Vue from 'vue'
import CpUrl from '../plugins/cp_url';
import Translate from '../plugins/translate';
import ResourceUrl from '../plugins/resource_url';
import FileIcon from '../plugins/file_icon';
import Can from '../plugins/can';
import Slugify from '../plugins/slugify';

Vue.use(CpUrl);
Vue.use(Translate);
Vue.use(ResourceUrl);
Vue.use(FileIcon);
Vue.use(Can);
Vue.use(Slugify);



// WEBPACK FOOTER //
// ./app/statamic/resources/js/bootstrap/plugins.js